module.exports = __webpack_public_path__ + "media/TERMINAL_PLATNICZY.86be290a.mp3";